import { OverlayTrigger, Tooltip } from 'react-bootstrap';
const About = () => {

    const skills = [
        { src: "/images/skills/reactjs.svg", className: "col-1 m-2", alt: "React", tooltip: "ReactJS (Material UI, Ant Design)" },
        { src: "/images/skills/nodejs.svg", className: "col-1 m-2", alt: "NodeJS", tooltip: "Node.js" },
        { src: "/images/skills/python.svg", className: "col-1 m-2", alt: "Python", tooltip: "Python (Django, Flask, Pandas, NumPy)" },
        { src: "/images/skills/java.svg", className: "col-1 m-2", alt: "Java", tooltip: "Java (Spring)" },
        { src: "/images/skills/javascript.svg", className: "col-1 m-2", alt: "JavaScript", tooltip: "JavaScript / TypeScript" },
        { src: "/images/skills/html5.svg", className: "col-1 m-2", alt: "HTML5", tooltip: "HTML5" },
        { src: "/images/skills/pwa.svg", className: "col-1 m-2", alt: "PWA", tooltip: "Progressive Web App (PWA)" },
        { src: "/images/skills/bootstrap.png", className: "col-1 m-2", alt: "Bootstrap", tooltip: "Bootstrap Framework" },
        { src: "/images/skills/gcc.svg", className: "col-1 m-2", alt: "GCC", tooltip: "C/C++ & Golang" },
        { src: "/images/skills/csharp.png", className: "col-2 m-2", alt: "C#", tooltip: "C# / .NET" },
        { src: "/images/skills/php.svg", className: "col-1 m-2", alt: "PHP", tooltip: "PHP Programming" },
        { src: "/images/skills/objc.svg", className: "col-1 m-2", alt: "Objective C", tooltip: "Objective C Programming" },
        { src: "/images/skills/android.svg", className: "col-1 m-2", alt: "Android ADK", tooltip: "Android Development Kit" },
        { src: "/images/skills/sql.svg", className: "col-1 m-2", alt: "SQL", tooltip: "SQL & data engineering" },
        { src: "/images/skills/mssql.svg", className: "col-1 m-2", alt: "Microsoft SQL", tooltip: "Microsoft SQL Server" },
        { src: "/images/skills/postgresql.svg", className: "col-1 m-2", alt: "PostgreSQL", tooltip: "PostgreSQL Server" },
        { src: "/images/skills/sqlite.svg", className: "col-2 m-2", alt: "SQLite", tooltip: "SQLite Database" },
        { src: "/images/skills/mongodb.svg", className: "col-1 m-2", alt: "MongoDB", tooltip: "MongoDB (NoSQL)" },
        { src: "/images/skills/redis.svg", className: "col-1 m-2", alt: "Redis", tooltip: "Redis / in-memory data" },
        { src: "/images/skills/bash.svg", className: "col-1 m-2", alt: "Bash", tooltip: "Linux Bash Scripting" },
        { src: "/images/skills/powershell.svg", className: "col-1 m-2", alt: "Powershell", tooltip: "Powershell Scripting" },
        { src: "/images/skills/git.svg", className: "col-1 m-2", alt: "git", tooltip: "Git & CI/CD (GitHub Actions)" },
        { src: "/images/skills/docker.svg", className: "col-1 m-2", alt: "Docker", tooltip: "Docker, Serverless, AWS & Azure" },
        { src: "/images/skills/jira.svg", className: "col-1 m-2", alt: "Jira", tooltip: "Jira Collaboration" },
        { src: "/images/skills/d3js.svg", className: "col-1 m-2", alt: "D3.js", tooltip: "D3.js" },
        { src: "/images/skills/leaflet.svg", className: "col-1 m-2", alt: "Leaflet.js", tooltip: "Leaflet.js" },
        { src: "/images/skills/arcgis.png", className: "col-1 m-2", alt: "ArcGIS", tooltip: "ArcGIS JS API" },
        { src: "/images/skills/owasp.webp", className: "col-2 m-2", alt: "OWASP", tooltip: "OWASP, CISSP, CSSLP, Cryptography" },
    ];

    const renderTooltip = (tooltipText) => (props) => (
        <Tooltip id={`tooltip-${tooltipText}`} {...props}>
            {tooltipText}
        </Tooltip>
    );

    return (
        <div className="container-fluid main-content">
            <article className="about mt-4">
                <h1>About Lam YongXian</h1>
                <img className="img-thumbnail float-end col-3" src="./images/profile.jpeg" alt="YongXian" />
                <p className="lead">
                Versatile Senior Software Engineer (Full Stack | Cybersecurity) with 12+ years of experience delivering secure, scalable, and high-performance applications. Expert in full-stack development, cloud architecture, and cybersecurity best practices. CISSP and CSSLP certified, with a track record leading complex R&amp;D initiatives—including critical infrastructure protection and contributions to annual cybersecurity exercises and hackathons. Committed to technical excellence through mentorship, architectural leadership, and security-by-design, with a growing focus on intelligent agentic workflows.
                </p>
                <div className="my-2 text-center seperator">
                    &bull; &bull; &bull;
                </div>
                <p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle-fill text-danger" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
                    </svg>
                    {" Open to Senior Software Engineering and Application Security roles in research labs, product teams, and organisations focused on cybersecurity, cloud, and AI. Keen to contribute to high-impact systems—from critical infrastructure and secure full-stack platforms to agentic AI workflows—and to collaborate on projects that can grow into production products or MVPs."}
                    </p>
                <div className="my-2 text-center seperator">
                    &bull; &bull; &bull;
                </div>
                <div className="text-center">
                    <p className="lead">Technical Skills</p>
                    {skills.map((skill, index) => (
                        <OverlayTrigger
                            key={index}
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltip(skill.tooltip)}
                        >
                            <img src={skill.src} className={skill.className} alt={skill.alt} />
                        </OverlayTrigger>
                    ))}
                </div>
            </article>
        </div>
    );
};

export default About;
